@if (breakpointService.isDesktop()) {
    <div class="info-blue">
        <div class="info-blue__empty info-blue__empty--occasion-genius"></div>
        <div class="info-blue__content">
            <div class="info-blue__text">
                Get event and occasion info before departure. For RoutePerfect members only - extra <strong>last
                minute</strong> event info En-Route
            </div>
        </div>
    </div>
}

<div class="viator" [class.viator--empty]="!isFetching">
    <button class="viator__reset"
            [class.show-filter]="showFilters"
            (click)="toggleFilters()">
        {{ (showFilters ? 'VIATOR.HIDE_FILTERS' : 'VIATOR.SHOW_FILTERS') | translate }}
    </button>
    <div class="viator__filters" [class.show-filter]="showFilters">
        @if (!isFetching) {
            <div class="viator__options">
                <div class="select-container">
                    <div class="custom-search mb-28">
                        <input class="custom-search__input"
                               type="text"
                               placeholder="Search event"
                               [disabled]="isFetching"
                               [(ngModel)]="occasionGeniusResponse.searchInput"
                               (ngModelChange)="occasionGeniusResponse.filterAndSortEvents({
                      searchInput: this.occasionGeniusResponse.searchInput,
                      sortDir: 'asc'
                   }); onFilterChange()"
                        >
                        <mat-icon class="custom-search__icon" [svgIcon]="eSvgIcons.SEARCH"></mat-icon>
                    </div>

                    <div #origin class="mb-16">
                        <mat-form-field class="datepicker" [floatLabel]="'always'">
                            <mat-label>Arriving on</mat-label>
                            <input (click)="showDateRangePanel(origin)"
                                   [disabled]="isFetching"
                                   [placeholder]="'Arriving on'"
                                   readonly
                                   matInput
                                   [value]="getDateValue()"
                            />
                        </mat-form-field>
                    </div>

                    <button class="custom-menu mb-47" [matMenuTriggerFor]="menu">
            <span class="custom-menu__placeholder">
              {{ selectedScoreValue.label ? selectedScoreValue.label : 'Popularity score' }}
            </span>
                        <mat-icon class="custom-menu__icon" [svgIcon]="eSvgIcons.ARROW_RIGHT"
                                  matDatepickerToggleIcon></mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        @for (score of scores; track score.value) {
                            <button mat-menu-item
                                    [class.custom-menu-active]="score === selectedScoreValue"
                                    (click)="onChangeScore(score); onFilterChange()">
                                {{ score.label }}
                            </button>
                        }
                    </mat-menu>
                </div>
            </div>

            <div class="viator__categories">
                @for (category of (occasionGeniusResponse.categoriesFilters | keyvalue); track category.key) {
                    <div class="filter-item">
                        <mat-checkbox
                                [checked]="category.value.state"
                                (change)="occasionGeniusResponse.updateCategoryFilterState(category.key, $event.checked); onFilterChange()"
                        >
                            {{ category.key }}
                        </mat-checkbox>
                        <span class="viator__count">{{ category.value.flags.length }}</span>
                    </div>
                }
            </div>
        } @else {
            @for (vi of fetchingFilters; track $index) {
                <ngx-skeleton-loader
                        [theme]="{height: 20 + 'px', margin: '0px 14px', marginBottom: '7px', maxWidth: '70%'}"
                ></ngx-skeleton-loader>
            }
        }
    </div>
    <div class="viator__groups" [class.show-filter]="showFilters">
        @if (!isFetching) {
            @if ((occasionGeniusResponse?.groupEventsByCategories() | keyvalue); as categories) {
                @if (categories && categories.length) {
                    @for (category of categories; track category.key) {
                        <div class="viator-group">
                            <h3 class="viator-group__title">
                                {{ category.key }}
                            </h3>

                            <div class="viator-group__swiper" appSwiper [swiperOptions]="swiperOptions">
                                <div class="swiper-wrapper">
                                    @for (event of category.value; track event.uuid) {
                                        @if (getCardEvent(event); as cardEvents) {
                                            <div class="swiper-slide">
                                                <app-occasion-genius-card
                                                        [events]="cardEvents"
                                                        [isFetching]="isFetching"
                                                        [placeId]="cityId"
                                                        [cityName]="cityName"
                                                        [countryName]="countryName"
                                                ></app-occasion-genius-card>
                                            </div>
                                        }
                                    }
                                </div>

                                <div class="swiper-button-prev with-background"></div>
                                <div class="swiper-button-next with-background"></div>
                            </div>
                        </div>
                    }
                } @else {
                    <app-no-items-found title="EMPTY.EVENTS"></app-no-items-found>
                }
            }
        } @else {
            @for (vi of fetchingItems; track $index) {
                <div class="viator-group">
                    <ngx-skeleton-loader
                            [theme]="{height: 40 + 'px', margin: 0, marginBottom: '15px', maxWidth: '30%'}"></ngx-skeleton-loader>
                    <app-viator-group
                            [isFetching]="isFetching"
                            [events]="[null, null, null, null]"
                    ></app-viator-group>
                </div>
            }
        }
    </div>
</div>
